import { isObject, isNumber } from 'lodash'
import { CELL_CONTENT_FLAG } from '../../../kye-table2/plugins/cell-content-width'
import { setUserData, setHistoryData } from '../plugins/drag-history-width'


/* table2相关宽度的转换 */
function accWidthMap (opt) {
  const keys = isObject(opt) ? Object.keys(opt) : []
  return keys.reduce((acc, key) => {
    const width = opt[key]['width']
    if (width) {
      acc[key] = width
    }
    return acc
  }, {})
}

export function updateColumnWidth (options, col) {
  const {
    localStoreColumnsOpt,
    localStorePreColumnsOpt,
    tableKey,
    updateColumnsOptSign,
  } = options

  const { key, width } = col

  const preColumn = localStorePreColumnsOpt[key]

  const storeColumn = localStoreColumnsOpt[key]
  if (preColumn && !updateColumnsOptSign) {
    const { width: preConfigWidth } = preColumn
    // 配置更新。每次等于则不走里面的逻辑。认为未更新配置
    if (preConfigWidth !== (isNumber(width) ? width : parseInt(width))) {
      // 删除缓存中的值，使用新的配置
      delete storeColumn['width']
      delete localStoreColumnsOpt[key]
      setUserData(tableKey, accWidthMap(localStoreColumnsOpt))
      if (preColumn) {
        // 删除上一次的配置中的值，下次好拖拽时使用当前的新配置
        delete preColumn['width']
        delete localStorePreColumnsOpt[key]
        setHistoryData(tableKey, accWidthMap(localStorePreColumnsOpt))
      }
    }
  }
}


export function table2ColumnWidthAmend (columnWidth) {
  if (columnWidth) {
    if (!isNumber(columnWidth)) {
      if (columnWidth === 'auto') {
        columnWidth = CELL_CONTENT_FLAG
      } else {
        columnWidth = parseInt(columnWidth)
      }
    }
  }
  return columnWidth
}



// WEBPACK FOOTER //
// ./src/public/components/query-table/table2/config/width.js